import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { generateSlug } from 'src/app/helpers/slug-helper';

@Component({
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss'],
})
export class ServiceCardComponent implements OnInit {
  @Input() srvLogoUrl!: string;
  @Input() serviceName!: string;
  @Input() displayName!: string;
  @Input() category!: string;
  @Input() categoryId!: any;
  @Input() schemeId!: string;

  constructor(private router: Router) {}

  ngOnInit() {}

  navigateToDeptInfo() {
    if(this.categoryId === '1000'){
      let url:any = `https://web.umang.gov.in/web_new/home/dbt-schemes?schemeId=${this.schemeId}&deptName=${this.category}&schemeName=${this.serviceName}`;
      window.open(url, '_self');
    }
    else{
      this.router.navigateByUrl(`/department/${generateSlug(this.displayName)}`);
    }
  }
}
